import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function evaluationCrewList(
  accountId: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${accountId}/evaluation/crew/list${queryString}`,
  );
}

export async function evaluationCrewCreate(accountId: string, payload: any) {
  return await clientAxios.post(
    `account/${accountId}/evaluation/crew/create`,
    payload,
  );
}

export async function evaluationCrewDelete(accountId: string, itemId: string) {
  return await clientAxios.del(
    `account/${accountId}/evaluation/crew/${itemId}/delete`,
  );
}
